import classNames from 'classnames';
import { useCallback } from 'react';

import useFormatImageUrl from '../../hooks/useFormatImageUrl';
import getImageSize from '../../lib/getImageSize';

import Blocks from '../../components/blocks/Blocks';
import RoundedButton from '../../components/buttons/RoundedButton';
import Body from '../../components/typography/Body';

import styles from './intro.module.css';

interface SurveyIntroProps {
    title?: string;
    image?: Image;
    blocks?: Block[];
    nextUrl?: string | null;
    placeholder?: boolean;
    className?: string;
    onCompleted: () => void;
}

function SurveyIntro({
    title,
    image = null,
    blocks = null,
    nextUrl = null,
    placeholder = false,
    className,
    onCompleted,
}: SurveyIntroProps) {
    const {
        url: imageUrl = null,
        width: imageWidth,
        height: imageHeight,
    } = getImageSize(image, 'large') || image || {};
    const formatImageUrl = useFormatImageUrl();
    const onClickStart = useCallback(
        (e) => {
            if (nextUrl !== null) {
                e.preventDefault();
            }
            if (onCompleted !== null) {
                onCompleted();
            }
        },
        [nextUrl, onCompleted],
    );
    const imageShouldCover =
        imageWidth !== null && imageHeight !== null && Math.abs(imageWidth / imageHeight) - 1 > 0.5;
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.imageShouldCover]: imageShouldCover,
                },
                className,
            ])}
        >
            <div className={styles.inner}>
                {imageUrl !== null || placeholder ? (
                    <div className={styles.imageContainer}>
                        {placeholder ? (
                            <div className={styles.placeholderImage} />
                        ) : (
                            <img
                                src={formatImageUrl(imageUrl)}
                                alt={title}
                                className={styles.image}
                                width={imageWidth}
                                height={imageHeight}
                            />
                        )}
                    </div>
                ) : null}
                <div className={styles.content}>
                    <Body className={styles.body}>
                        <h1>{title}</h1>
                        <Blocks
                            blocks={
                                placeholder
                                    ? [{ type: 'placeholder', maxCharacters: 30 }]
                                    : blocks || []
                            }
                            withoutMaxWidth
                        />
                    </Body>
                    <RoundedButton href={nextUrl} onClick={onClickStart} className={styles.button}>
                        Commencer →
                    </RoundedButton>
                </div>
            </div>
        </div>
    );
}

export default SurveyIntro;
